import { Pipe, PipeTransform } from "@angular/core";
import { formatCurrency } from "@angular/common";
import { GlobalUserSettingValues } from "../constants/setting-keys";

/** Display currency of the Ghana deployment. XAF is never shown. */
const DEFAULT_CURRENCY = "GHS";

@Pipe({
  name: "appCurrency",
})
export class AppCurrencyPipe implements PipeTransform {
  /**
   * {{ amount | appCurrency }}            -> "GHS 20.00"
   * {{ amount | appCurrency: row.currency }} -> uses the row currency (e.g. "USD 5.00"), GHS when empty.
   */
  transform(
    value: number | string | undefined | null,
    currency?: string | null,
  ): string {
    if (value == null || value === "") {
      value = 0;
    }
    let prefix = (currency ?? "").trim().toUpperCase();
    if (!prefix || prefix === "XAF") {
      const configured = (GlobalUserSettingValues.CurrencyPrefix ?? "")
        .trim()
        .toUpperCase();
      prefix = configured && configured !== "XAF" ? configured : DEFAULT_CURRENCY;
    }
    return formatCurrency(+value, "en", prefix + " ", "", "2.2-2");
  }
}
